module.exports = __webpack_public_path__ + "img/icon-pedidos-asistencia-tecnica.56ca8813.svg";